import { FilePresent, Send } from "@mui/icons-material";
import {
	Avatar,
	Badge,
	IconButton,
	Paper,
	Tab,
	Tabs,
	Typography,
	useTheme,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { CommentTable, CommentData } from "../interfaces/Comment";
import { CreateComment, GetComments } from "../requester/functions";
import { MAIN_URL, P } from "../requester/requester";
import DataTextField from "./DataInputs/DataTextField";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import FileIcon from "./FileIcon";
import { InfinityPagination } from "../hooks/Pagination";
import dateToHuman from "../utilities/date";

interface IProps {
	id_obj: number;
	type: string;
	onHeaderClick?: () => void;
	className?: string;
}

const template: CommentData = {
	text: "",
};

const CommentBox = (props: IProps) => {
	const theme = useTheme();

	const [newComment, setNewComment] = useState<CommentData>({
		...template,
		id_obj: props.id_obj,
		type: props.type,
	});
	const [mode, setMode] = useState<"file" | undefined>(undefined);
	const [tab, setTab] = useState<number>(0);

	const list = useRef<any>(undefined);
	const fileInput = useRef<any>(undefined);
	const [file, setFile] = useState<any>();

	const [comments, setComments] = useState<CommentTable[]>([]);

	const onChangeTab = (event: any, newValue: number) => {
		setTab(newValue);
		setMode(newValue === 0 ? undefined : "file");
	};

	const onSend = () => {
		CreateComment({ data: { ...newComment }, file: file }, (resp) => {
			setNewComment({
				...template,
				id_obj: props.id_obj,
				type: props.type,
			});
			setFile(undefined);
			fileInput.current.value = "";
			getComments();
		});
	};

	const getComments = () => {
		GetComments(
			{
				filter_by: {
					id_obj: props.id_obj,
					type: props.type,
					message_type: mode,
				},
				pagination: InfinityPagination,
			},
			(resp) => {
				if (resp.status === "ok" && resp.data) {
					setComments(resp.data.data);
				}
			}
		);
	};

	useEffect(() => {
		list.current.scrollTo(0, list.current.scrollHeight);
	}, [comments]);

	useEffect(() => {
		getComments();
	}, [props.id_obj, props.type, mode]);

	return (
		<Paper className="w-80 h-[30rem] flex flex-col justify-between">
			<Paper
				className="h-14 flex justify-center items-center text-xl"
				style={{
					backgroundColor: theme.palette.primary.main,
					cursor: props.onHeaderClick ? "pointer" : "auto",
				}}
				onClick={() => props.onHeaderClick?.()}
			>
				<Typography className="text-white text-2xl">Комментарии</Typography>
			</Paper>
			<Tabs className="w-full" value={tab} onChange={onChangeTab}>
				<Tab className="w-1/2" label="Сообщения" />
				<Tab className="w-1/2" label="Файлы" />
			</Tabs>
			<div
				className="w-full h-full flex flex-col gap-2 p-2 overflow-auto"
				ref={list}
			>
				{comments.map((item, index) => (
					<div className="flex" key={`comment-${item.id}`}>
						<Link to={`/manager/${item.author.id}`} className="mr-3">
							<Avatar
								src={`${MAIN_URL}manager/avatar/${item.author.avatar}`}
								style={{
									opacity:
										index > 0 &&
										comments[index].author.id === comments[index - 1].author.id
											? 0
											: 1,
								}}
							/>
						</Link>
						<div className="w-full flex flex-col gap-2">
							{index > 0 &&
							comments[index].author.id ===
								comments[index - 1].author.id ? null : (
								<div className="p-2 text-sm">
									<div className="text-sm">{item.author.full_name}</div>
								</div>
							)}
							{item.text ? (
								<Paper className="p-2">
									<Typography>{item.text}</Typography>
								</Paper>
							) : null}
							{item.file ? (
								<Paper>
									<a
										href={`${MAIN_URL}${P.CommentFile}/${item.file}`}
										download={item.filename ?? item.file}
									>
										<IconButton>
											<FileIcon fileName={item.file} />
										</IconButton>
										{item.filename ?? "Скачать"}
									</a>
								</Paper>
							) : null}
							<div className="p-2 text-xs flex items-end">
								<div className="text-xs">{dateToHuman(item.creation_date)}</div>
							</div>
						</div>
					</div>
				))}
			</div>
			<div className="flex w-full px-2 align-middle items-center justify-between">
				<DataTextField
					value={newComment}
					setValue={setNewComment}
					keyValue="text"
					inputProps={{
						placeholder: "Введите сообщение",
						multiline: true,
					}}
					className="w-full"
				/>
				<input
					type="file"
					ref={fileInput}
					style={{ display: "none" }}
					onChange={(ev) => {
						if (ev.target.files) {
							const fi = ev.target.files[0];
							setFile(fi);
						}
					}}
				/>
				<Badge color="primary" variant={"dot"} invisible={file === undefined}>
					<IconButton
						onClick={() => {
							fileInput.current.click();
						}}
					>
						<AttachFileIcon />
					</IconButton>
				</Badge>
				<IconButton
					onClick={() => onSend()}
					color="primary"
					disabled={!file && !newComment.text}
				>
					<Send />
				</IconButton>
			</div>
		</Paper>
	);
};

export default CommentBox;
